module.exports = __webpack_public_path__ + "img/21.2919bdc0.png";